import { nextTick } from "vue";
let modalOpened = false;
let lastScreenHeight = 0;
let heightChanged = false;
export function sendHeight(closeModal = false) {
    nextTick(() => {
        let height = document.documentElement.scrollHeight;
        if (document.getElementById('contextModal')) {
            //checks if the screen height increased significantly when a modal is opened (happens if modal is at bottom of iframe view)
            if (window.innerHeight > 500 && window.innerHeight > lastScreenHeight) {
                heightChanged = true;
            }
            const modalHeight = document.getElementById('contextModal')?.clientHeight || 0;
            height = Math.max(height, modalHeight + 100);
            // Check if the modal exceeds the current height due to absolute positioning
            const modal = document.getElementById('contextModal');
            if (modal) {
                const modalRect = modal.getBoundingClientRect();
                const modalBottom = modalRect.top + window.scrollY + modalRect.height;
                height = Math.max(height, Math.ceil(modalBottom) + 100);
            }
            modalOpened = true;
        }
        else if (modalOpened) {
            modalOpened = false;
            if (heightChanged) {
                height = 100;
                heightChanged = false;
            }
        }
        lastScreenHeight = window.innerHeight;
        window.parent.postMessage({ type: "heightUpdate", height }, "*");
    });
}
export function observeDOMChanges() {
    const observer = new MutationObserver(() => sendHeight());
    observer.observe(document.body, { childList: true, subtree: true, attributes: true });
    const resizeObserver = new ResizeObserver(() => sendHeight());
    resizeObserver.observe(document.body);
}
